var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = _objectWithoutProperties(_ref, ["styles"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50",
    height: "50",
    viewBox: "-25.6 -25.6 307.20 307.20",
    version: "1.2",
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    stroke: "#fff"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: "-25.6",
    y: "-25.6",
    width: "307.2",
    height: "307.2",
    rx: "153.6",
    fill: "#fb9a00",
    stroke: "none",
    strokeWidth: "0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M113.2 72.2h53.9c2 0 3-1 3-2.9 0-.7-.2-1.3-.5-1.8l-12.1-26.3c-1.3-2.1-3-2.7-5.3-2.7h-39c-3.7 0-5.5 1.8-5.5 5.5v22.7c0 3.7 1.8 5.5 5.5 5.5zm26.2-28.3c6.6 0 12 5.4 12 12s-5.4 12-12 12-12-5.4-12-12 5.3-12 12-12zM204.8 131.5c-4.4 0-7.9 3.5-7.9 7.9s3.5 7.9 7.9 7.9 7.9-3.5 7.9-7.9-3.5-7.9-7.9-7.9zM49.6 72.3h42.2c2.7 0 4.8-2.2 4.8-4.8V43.3c0-2.7-2.2-4.8-4.8-4.8H53.6c-3.7 0-5.5 1.8-5.5 5.5l-4 22.8c0 3.7 1.8 5.5 5.5 5.5zM65 43.9c6.6 0 12 5.4 12 12s-5.4 12-12 12-12-5.4-12-12 5.4-12 12-12zM55.5 131.5c-4.4 0-7.9 3.5-7.9 7.9s3.5 7.9 7.9 7.9 7.9-3.5 7.9-7.9-3.5-7.9-7.9-7.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "139.4",
    cy: "55.9",
    r: "12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5 115.8c-13.1 0-23.7 10.6-23.7 23.7s10.6 23.7 23.7 23.7 23.7-10.6 23.7-23.7-10.6-23.7-23.7-23.7zm0 31.5c-4.4 0-7.9-3.5-7.9-7.9s3.5-7.9 7.9-7.9 7.9 3.5 7.9 7.9-3.5 7.9-7.9 7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3 134H21c.6-8.1 4.3-15.1 11.2-20.8s14.6-8.6 23.1-8.6 16.3 2.9 23.3 8.6 10.8 12.7 11.3 20.8h80.4c.6-8.1 4.4-15.1 11.3-20.8 7-5.7 14.7-8.6 23.3-8.6 8.5 0 16.2 2.9 23.1 8.6 6.9 5.7 10.6 12.7 11.2 20.8h6.7c4.8 0 7.3-2.4 7.3-7.3v-12.6h-6.9v-12V89.5c0-8.6-7.5-15.5-16.9-15.5h-40.7l-22.3-40.2c-1.9-3.6-6.4-5.6-10.3-5.6H49.5c-4.8-.1-9.1 2.9-10.5 7.6L30.5 74h.4C21.6 74 14 80.9 14 89.5v24.6H7v12.6c0 4.8 2.4 7.3 7.3 7.3zm93.4-90c0-3.7 1.8-5.5 5.5-5.5h39c2.3 0 4 .6 5.3 2.7l12.1 26.3c.3.5.5 1.1.5 1.8 0 1.9-1 2.9-3 2.9h-53.9c-3.7 0-5.5-1.8-5.5-5.5V44zm-59.6 0c0-3.7 1.8-5.5 5.5-5.5h38.2c2.6 0 4.8 2.1 4.8 4.8v24.2c0 2.6-2.1 4.8-4.8 4.8H49.6c-3.7 0-5.5-1.8-5.5-5.5l4-22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.8 115.8c-13.1 0-23.7 10.6-23.7 23.7s10.6 23.7 23.7 23.7 23.7-10.6 23.7-23.7-10.6-23.7-23.7-23.7zm0 31.5c-4.4 0-7.9-3.5-7.9-7.9s3.5-7.9 7.9-7.9 7.9 3.5 7.9 7.9-3.5 7.9-7.9 7.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "65",
    cy: "55.9",
    r: "12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.5 165c-3.5-4.2-14.7-11-27.5-11s-23.4 6.8-26.6 11H1.3v11H254v-11h-98.5z"
  }));
});